import {
  SUBMIT_USERS,
  SUBMIT_USERS_SUCCESS,
  SUBMIT_USERS_FAILS,
  FETCH_USERS,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILS,
  FETCH_USER_BY_ID,
  FETCH_USER_BY_ID_FAILS,
  FETCH_USER_BY_ID_SUCCESS
} from './UserActionTypes';

export const userReducer = (
  state = {
    fetching: false,
    error: { status: false, message: '' },
    data: [],
    selectedUser: {}
  },
  action
) => {
  switch (action.type) {
    case SUBMIT_USERS:
      return Object.assign({}, state, { fetching: true });

    case SUBMIT_USERS_SUCCESS:
      return {
        ...state,
        fetching: false,
        error: { status: false, message: '' }
      };

    case SUBMIT_USERS_FAILS:
      return {
        ...state,
        fetching: false,
        error: { status: true, message: 'User submit fails' },
        data: []
      };

    case FETCH_USERS:
      return Object.assign({}, state, { fetching: true });

    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        fetching: false,
        error: { status: false, message: '' },
        data: action.payload?.data || []
      };

    case FETCH_USERS_FAILS:
      return {
        ...state,
        fetching: false,
        error: { status: true, message: 'user fetch fails' },
        data: []
      };

    case FETCH_USER_BY_ID:
      return Object.assign({}, state, { fetching: true });

    case FETCH_USER_BY_ID_SUCCESS:
      return {
        ...state,
        fetching: false,
        error: { status: false, message: '' },
        selectedUser: action.payload?.data || {},
      };
      
    case FETCH_USERS_FAILS:
      return {
        ...state,
        fetching: false,
        error: { status: true, message: 'user fetch fails' },
        selectedUser: action.payload?.data || {},
      };
    default:
      return state;
  }
};
